function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.504 3.867V2.93A2.933 2.933 0 0013.574 0H6.387a2.933 2.933 0 00-2.93 2.93v.937h13.047zM4.629 12.46v6.368c0 .647.525 1.172 1.172 1.172h8.36c.646 0 1.171-.525 1.171-1.172v-6.367H4.629zm6.914 5H8.418a.586.586 0 110-1.17h3.125a.586.586 0 110 1.17zm0-2.5H8.418a.586.586 0 110-1.17h3.125a.586.586 0 110 1.17z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.05 5.04H2.95A2.933 2.933 0 00.02 7.968v4.687a2.933 2.933 0 002.93 2.93h.507V12.46h-.352a.586.586 0 110-1.172H16.856a.586.586 0 110 1.172h-.352v3.125h.547a2.933 2.933 0 002.93-2.93V7.97a2.933 2.933 0 00-2.93-2.93zM4.98 8.71H3.105a.586.586 0 010-1.17H4.98a.586.586 0 010 1.17z",
  fill: "#fff"
});

function SvgIconPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconPrint;